import {h, Component, createRef} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from "../constants";
import Text from "../canvas/text";
import store from "../store";
import util, {roundOneDecimalScaled} from "../util";
import Interactable from "../canvas/interactable";
import FontSize from "./svg/FontSize";
import { DownOutlined } from '@ant-design/icons';

export default @connect(reduce, actions)
class TextSizeWidget extends Component {
  constructor(props) {
    super();

    this.ref = createRef();

    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSizeFieldBlur = this.onSizeFieldBlur.bind(this);
    this.onInputClick = this.onInputClick.bind(this);
    this.disableEditedText = this.disableEditedText.bind(this);

    this.initElement(props);
  }

  getScale() {
    return Interactable.of(this.$element).getScale();
  }

  onSelect(size) {
    this.props.onChange(size);
  }

  onChange(ev) {
    const sizeString = ev.target.value;
    if (!sizeString.endsWith('.')) {
      const size = parseFloat(sizeString) || 0;

      this.props.onChange(size);
      if (this.ref.current) {
        this.ref.current.focus();
      }
    }
  }

  onSizeFieldBlur(ev) {
    let size = parseFloat(ev.target.value) || 0;
    if (size < 1) size = 1;
    if (size > 400) size = 400;
    this.props.onChange(size);

    if (!store.getState().isMobileVersion) {
      Text.restoreSelection(this.props.$element);
    }
  }

  disableEditedText() {
    // Text.disableActiveEdit(this.props.$element);
  }

  onInputClick() {
    // Text.disableActiveEdit(this.props.$element);
  }

  initElement(props) {
    this.$element = props.$element;

    if (this.$element) {
      this.throttledForceUpdate = util.throttle(() => this.forceUpdate(), 50);

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new window.MutationObserver(mutations => mutations.forEach(this.throttledForceUpdate.bind(this)))
      this.observer.observe(this.$element[0], {
        attributes: true,
        attributeFilter: ['style'],
      });
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.initElement(nextProps);
  }

  render(props, state) {
    let value = roundOneDecimalScaled(props.value * this.getScale());

    return (
      <div className="dropdown">
        {!props.isMobileVersion || (props.isMobileVersion && props.isMobileAside) ? 
        <a className="dropdown-toggle car sm">
          <input className="textsize-input change-size-input" value={value} key={'input'} ref={this.ref} onChange={this.onChange} onBlur={this.onSizeFieldBlur} onMouseDown={this.disableEditedText}/>
        </a> :
        <a className="dropdown-toggle mobile-tool-widget">
          <FontSize/>
          <span>Font Size</span>
        </a>}
        <div className="dropdown-menu textsize-dropdown left saf-stop">
          {props.isMobileVersion && !props.isMobileAside && <div className="mobile-dropdown-header">
            <span>Font Size</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <div className="scroll">
            <ul>
              {constants.sizes.map((size) => <li key={size}><a onClick={() => this.onSelect(size)}>{size}</a></li>)}
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
